// src/redux/cartSlice.js
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

// 1. Async Thunk to Fetch Cart Count from API
export const fetchCartCount = createAsyncThunk("cart/fetchCount", async () => {
    const token = localStorage.getItem("authToken");
    if (!token) return 0;

    try {
        const res = await axios.get("http://localhost:8080/api/cart/my", {
            headers: { Authorization: `Bearer ${token}` },
        });
        return res.data.length; // Return the number of items
    } catch (err) {
        console.error("Redux: Error fetching cart", err);
        return 0;
    }
});

// 2. Create Slice
const cartSlice = createSlice({
    name: "cart",
    initialState: {
        count: 0,
    },
    reducers: {
        // Optional: Manual clear if needed on logout
        clearCartCount: (state) => {
            state.count = 0;
        }
    },
    extraReducers: (builder) => {
        builder.addCase(fetchCartCount.fulfilled, (state, action) => {
            state.count = action.payload;
        });
    },
});

export const { clearCartCount } = cartSlice.actions;
export default cartSlice.reducer;